module.exports = __webpack_public_path__ + "static/hero-image-mobile-dcb7f4d51e40dd511dad34daccc926d9.jpg";